module.exports = __webpack_public_path__ + "images/dice-icon-valentines-049a41d963873601b3f01a684d9ad26b.png";